import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../../commonComponents/translate';

function AvailabilityEvent({ t, availability, index }) {
  const startDate = moment(availability.startDate);
  const endDate = moment(availability.endDate);

  const startDateAux = startDate.format('DD MMM');
  const endDateAux = endDate.format('DD MMM');

  const showSecondDate = startDate.isSame(endDate, 'day');
  const colSize = !showSecondDate ? 'col-lg-1' : 'col-lg-3 col-4';

  return (
    <div className="row sessions-holder">
      <div className="col-lg-2 col-3 resize-dates">
        <div className={`${colSize} day-session`}>
        <span>
          {startDate.format('DD')}
        </span>
          <span>
          {startDate.format('MMM')}
          </span>
        </div>
        {!showSecondDate &&
        <div className="col-1 day-session day-session-separator">
            <span>
              -
            </span>
        </div>
        }
        {!showSecondDate &&
          <div className="col-3 day-session">
            <span>
              {endDate.format('DD')}
            </span>
            <span>
              {endDate.format('MMM')}
            </span>
          </div>
        }
      </div>
      <div className="col-5 name-session">
        <span className={`status-${availability.status}`}>
          {t(availability.status)}
        </span>
        <span>
          {`From ${startDateAux} to ${endDateAux}`}
        </span>
      </div>
      <div className="col-2">
        <button type="button" className="edit-session edit-availability" data-availability-index={index}>
          <i className="fas fa-pen" />
        </button>
        <button type="button" className="remove-session remove-availability" data-availability-index={index}>
          <i className="la la-trash" />
        </button>
      </div>
    </div>
  );
}

AvailabilityEvent.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  availability: PropTypes.arrayOf.isRequired,
  index: PropTypes.number.isRequired,
};

export default translate(AvailabilityEvent);
